import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  BTNS: '[data-fragment="UspList.btn"]',
  TEXTS: '[data-fragment="UspList.text"]',
};

class UspList extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      itemVisible: false,
    };
    this.showItem = this.showItem.bind(this);
    this.hideItems = this.hideItems.bind(this);
  }

  didMount() {
    this.btns = this.element.querySelectorAll(fragments.BTNS);
    this.texts = this.element.querySelectorAll(fragments.TEXTS);
    this.btns.forEach((btn) => {
      btn.addEventListener('click', this.showItem);
    });
    document.body.addEventListener('click', this.hideItems);
  }

  showItem(e) {
    this.setState({
      itemVisible: true,
    });
  	this.btn = e.target;
    this.text = e.target.querySelector('.usp-list-small__text');
    if (this.btn.classList.contains('active')) {
      this.btn.classList.toggle('active');
    } else {
      // remove all
      this.btns.forEach((btn) => {
        btn.classList.remove('active');
      });
      // add to current
      this.btn.classList.add('active');
    }
  }
  hideItems(e) {
    // remove all
    if (!e.target.classList.contains('usp-list-small__btn')) {
      this.btns.forEach((btn) => {
        btn.classList.remove('active');
      });
    }
  }
  willUnMount() {
    this.btns.forEach((btn) => {
      btn.removeEventListener('click', this.showItem);
    });
    document.body.removeEventListener('click', this.hideItems);
  }
  update() {
    const { itemVisible } = this.state;
    classNames(this.element, { 'usp-list--shows-item': itemVisible });
  }
}

export default UspList;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/UspList.js